module.exports = __webpack_public_path__ + "img/sayed.d33387c1.png";